import Swiper from '../autoload/_swiper';

export default {
  init() {
    // JavaScript to be fired on all pages

      $('#show-menu').click(function() {

          console.log('show menu clicked');

          var $body =  $('body');
          var $banner =  $('.banner');
          var $footer =  $('.main-footer');

          if ($banner.hasClass('open')) {

              $banner.removeClass('open');
              $footer.removeClass('open');
              $body.removeClass('nav-open');

          } else {

              $banner.addClass('open');
              $footer.addClass('open');
              $body.addClass('nav-open');
          }

      });

      if ($('.section-gallery').length) {
          console.log('.section-gallery');

          var swiper = new Swiper('.gallery-swiper', {
              slidesPerView: 'auto',
              centeredSlides: true,
              speed: 700,
              loop: true,
              autoplay: {
                  delay: 5000,
                  disableOnInteraction: false,
              },
              spaceBetween: 0,
              pagination: {
                  el: '.swiper-pagination',
                  clickable: true,
              },
          });

          //swiper.slideTo(1);

          setTimeout(function() {  swiper.slideTo(1); }, 300);

      }

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js